export enum TUTORIALS_ADMIN {
    /**
     * @value Upload slide image
     */
    SLIDE_UPLOAD = 'ADMIN_MODULE_TUTORIAL_SLIDE_SETTINGS_UPLOAD',
}
